/* Packages */
import React from 'react';
import {render} from 'react-dom';

/* Components */
import Conversion from './components/Conversion';

/* Helpers */
import {parseDataToProps} from '../helpers';

const conversionNodes = document.querySelectorAll('.conversion');
[...conversionNodes].forEach((node) => render(<Conversion {...parseDataToProps(node.dataset)} />, node));
